import { createContext, use } from "react";

import type { ReceiptUploadRequest } from "@bokio/components/UploadReceiptProvider/UploadReceiptProvider";
import type { Listener } from "@bokio/shared/services/api/signalRHub";

export type UploadMessage = { historic?: boolean } & (
	| { type: "started"; file: File[] }
	| { type: "done"; request: ReceiptUploadRequest }
	| { type: "change" | "allDone"; requests: ReceiptUploadRequest[] }
);

export interface UploadContextType {
	invokeUpload: (rerouteToBookkeepingOnSingleUpload?: boolean) => void;
	requests?: ReceiptUploadRequest[];
	addListener: (listener: Listener<UploadMessage>) => void;
	removeListener: (listener: Listener<UploadMessage>) => void;
	setGlobalFileDropZoneBlockerCounter: (stateUpdater: (counter: number) => number) => void;
	uploadError?: string;
	clearUploadError: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const UploadContext = createContext<UploadContextType>({} as any);

export const useUploadContext = () => use(UploadContext);
